export default "__VITE_ASSET__D1RLqCw6__"